import { EntityLevel } from '@suntex.fim/enums';

import {
  type EntityLayoutProps,
  createEntityLayout,
} from './createEntityLayout';

export type DistrictLayoutProps = EntityLayoutProps;

/** Layout wrapper for district-scoped routes (`/district/:districtId/...`). */
export const DistrictLayout = createEntityLayout({
  entityLevel: EntityLevel.District,
  paramName: 'districtId',
});
